import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Text, Relative, Tooltip } from 'pcln-design-system'
import PropTypes from 'prop-types'

const StyledToolTip = styled(Tooltip)`
  white-space: nowrap;
`

const Dot = styled(Box)`
  margin-top: 2px;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  @media screen and (min-width: 375px) {
    margin-top: 0px;
    height: 7px;
    width: 7px;
  }
`

const LayoverText = styled(Text)`
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  visibility: hidden;
  white-space: nowrap;
  @media screen and (min-width: 375px) {
    ${(props) => !props.hideStops && !props.isHideDurationSm && 'visibility: visible;'}
  }
  ${(props) => props.theme.mediaQueries.md} {
    ${(props) => !props.hideStops && props.isHideDurationSm && 'visibility: visible;'}
  }
  ${(props) => props.theme.mediaQueries.lg} {
    font-size: 12px;
    ${(props) => !props.hideStops && 'visibility: visible;'}
  }

  ${(props) => props.theme.mediaQueries.xxl} {
    visibility: visible;
  }
`

const defaultProps = {
  location: '',
  duration: '',
  stopTitle: '',
  enableTooltip: true,
}

const propTypes = {
  /** Layover location */
  location: PropTypes.string,

  /** textColor ternary result */
  textColor: PropTypes.string,

  /** Airport name used for tooltip */
  stopTitle: PropTypes.string,

  /** Layover duration */
  duration: PropTypes.string,

  /** Hide stops at smaller breakpoints */
  hideStops: PropTypes.bool,

  /** Enable the tooltip (default true) */
  enableTooltip: PropTypes.bool,

  /** Hide layover text for "sm" mediaquery */
  isHideDurationSm: PropTypes.bool,
}

const ToggleToolTip = (bool, toggleToolTip) => () => {
  toggleToolTip(bool)
}

const StopsDisplay = ({ location, stopTitle, duration, textColor, hideStops, enableTooltip }) => {
  const [showToolTip, toggleToolTip] = useState(false)
  const stopPropagation = (e) => e.stopPropagation()

  return (
    <Box
      key={location}
      onMouseEnter={ToggleToolTip(true, toggleToolTip)}
      onMouseLeave={ToggleToolTip(false, toggleToolTip)}
      // onClick prevents tooltip click from selecting listing
      onClick={stopPropagation}
    >
      <Relative>
        {enableTooltip && showToolTip && (
          <StyledToolTip bg='background.darkest' color='text.lightest' zIndex={1} top center>
            {`${duration} layover, ${stopTitle}`}
          </StyledToolTip>
        )}
        <LayoverText
          fontSize={0}
          color={textColor}
          mb='1px'
          data-testid='layover-airport'
          hideStops={hideStops}
          isHideDurationSm
        >
          {duration || <Box height='16px' />}
        </LayoverText>
        <Dot bg={'text.light'} m='auto' />
        <LayoverText
          fontSize={0}
          color={textColor}
          mt='4px'
          data-testid='layover-duration'
          hideStops={hideStops}
        >
          {location}
        </LayoverText>
      </Relative>
    </Box>
  )
}

StopsDisplay.propTypes = propTypes

StopsDisplay.defaultProps = defaultProps

export default StopsDisplay
